import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../../Common/PaginatedTable';
import { HiPencilAlt, HiXCircle } from 'react-icons/hi';
import { UserTerritory } from '../../../Models/UserTerritory';

export default function UserTerritoryListTable({
  data,
  deleteUserTerritory,
  editUserTerritory,
}: {
  data: UserTerritory[];
  deleteUserTerritory(id: number): void;
  editUserTerritory: (feature: UserTerritory) => void;
}) {
  const columnHelper = createColumnHelper<UserTerritory>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => editUserTerritory(info.row.original)}
          >
            <HiPencilAlt />
          </button>
          <button
            type='button'
            className='buttonCancel p-2'
            onClick={() => deleteUserTerritory(info.getValue())}
          >
            <HiXCircle />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.territory?.name, {
      id: 'nameId',
      header: 'Name',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
    columnHelper.accessor((row) => row.territory?.number, {
      id: 'numberId',
      header: 'Number',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
      sorting: [
        {
          id: 'id',
          desc: false,
        },
      ],
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
